/**
 * Plain text with links in it -> safe HTML.
 *
 * Supervisors write hints for the receiving bench; a hint that says "see the
 * test procedure" wants to link to it. Two forms are understood:
 *
 *   [test procedure](https://wiki.example.com/fluke-87v)
 *   https://wiki.example.com/fluke-87v
 *
 * Everything else is escaped, so the hint can never carry markup of its own.
 * Only http and https links are made clickable; anything else stays text.
 */
const escape = (s) => String(s)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')

const anchor = (href, label) =>
    `<a href="${escape(href)}" target="_blank" rel="noopener noreferrer">${escape(label)}</a>`

export default function linkify(text) {
  if (!text) return ''
  const out = []
  let last = 0
  // [label](url) first, then bare urls, in one pass so a labelled link's url is not linked twice
  const re = /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)|(https?:\/\/[^\s<>"')\]]+)/g
  let m
  while ((m = re.exec(text))) {
    out.push(escape(text.slice(last, m.index)))
    if (m[1]) out.push(anchor(m[2], m[1]))
    else {
      // a trailing full stop or comma belongs to the sentence, not the link
      let url = m[3]
      let tail = ''
      while (/[.,;:!?]$/.test(url)) { tail = url.slice(-1) + tail; url = url.slice(0, -1) }
      out.push(anchor(url, url) + escape(tail))
    }
    last = m.index + m[0].length
  }
  out.push(escape(text.slice(last)))
  return out.join('')
}

/**
 * Click handler for a v-html hint. A link inside an answer row must open the
 * link and nothing else; a tap on the plain words still picks the answer.
 */
export function stopLinkClick(e) {
  if (e.target && e.target.closest && e.target.closest('a')) e.stopPropagation()
}
